import React, { useState } from 'react';
import { TextInput } from 'carbon-components-react';

const CustomSubformTextInput = props => {
  const [value, setValue] = useState(props.formData);

  const onChange = event => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  return (
    <div style={{ marginTop: 24 }}>
      <TextInput
        id={props.idSchema.$id}
        type={props.uiSchema['ui:options'] || 'text'}
        light
        invalid={false}
        invalidText='A valid value is required'
        labelText={props.schema.title}
        placeholder={props.schema.placeholder}
        onChange={onChange}
        value={value || ''}
        disabled={props.schema.readOnly || props.readonly}
        style={{
          background: 'white',
          width: '100%',
          minWidth: '200px'
        }}
      />
    </div>
  );
};

export default CustomSubformTextInput;
